import { useState } from "react";
import { useParams } from "react-router-dom";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { TouchBallLoading } from "react-loadingg";

import useAxios from "../../services/useAxios";

import { ReactSelect, CustomInput } from "../kits/Inputs/Inputs";
import CustomButton from "../kits/button/CustomButton";
import ToastCustomize from "../kits/ToastCustomize";
import { SearchIcon, TrashIcon } from "../kits/Icons";
import ColorSchema from "../kits/Color";

export default function ProductItemForOrder({
  dataItem,
  dispatch,
  ACTIONS,
  productDebounce,
  productListState,
  order,
}) {
  const { typeId } = useParams();
  const { execute: callForPriceApi } = useAxios("order/calculate_price");
  const [loadingPrice, setLoadingPrice] = useState(false);
  const callPriceValidation = () => {
    let propertyTemp = dataItem?.product?.properties;
    let txt = "";
    let validate = true;
    if (
      dataItem?.product?.value == undefined ||
      dataItem?.product?.value == null ||
      dataItem?.product?.value == ""
    ) {
      txt = "لطفا ابتدا محصول را انتخاب کنید.";
    } else {
      for (let i = 0; i < propertyTemp.length; i++) {
        if (propertyTemp[i]?.input_value == "") {
          txt = "لطفا مقادیر صفتها را پر کنید.";
        } else if (
          parseInt(propertyTemp[i]?.input_value) >
            parseInt(propertyTemp[i]?.max_input) ||
          parseInt(propertyTemp[i]?.input_value) <
            parseInt(propertyTemp[i]?.min_input)
        ) {
          txt = "مقادیر صفتها باید در بازه های تعریف شده باشد";
        }
      }
    }

    if (txt != "") {
      validate = false;
      ToastCustomize({
        mainText: txt,
        duration: 2000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
    }
    return validate;
  };
  const callForPriceFunc = () => {
    setLoadingPrice(true);
    callForPriceApi({ product_id: dataItem?.product?.value }).then((res) => {
      dispatch({
        type: ACTIONS.CHANGEITEM,
        payload: { price: res.price ?? 0, call_price: true },
        custom_id: dataItem.custom_id,
      });
      setLoadingPrice(false);
    });
  };
  console.log("dataItem", dataItem);
  return (
    <div className="create-order-product-item px-2 pt-3 pb-1 my-2 d-flex flex-wrap">
      <div className="product-width mx-1">
        <ReactSelect
          title="انتخاب محصول"
          itemsList={productListState}
          inputValue={dataItem?.product}
          inputSize=""
          activate={
            order == "edit" && dataItem?.added == undefined ? false : true
          }
          onChangeFunc={(e) =>
            dispatch({
              type: ACTIONS.CHANGEITEM,
              payload: {
                product: {
                  ...e,
                  properties:
                    e?.properties?.map((v) => {
                      return { ...v, input_value: "" };
                    }) ?? [],
                },
                discount: e.discount,
                id: e.value,
              },
              custom_id: dataItem.custom_id,
            })
          }
          onInputChangeFunc={(value) => {
            productDebounce(value);
          }}
        ></ReactSelect>
      </div>
      <div className="mx-1">
        <CustomInput
          id="titleTour"
          label="تعداد "
          inputSize="same-as-select"
          type="text"
          inputContainer="count-width"
          inputValue={addCommas(dataItem?.count)}
          onChangeFunc={(e) =>
            dispatch({
              type: ACTIONS.CHANGEITEM,
              payload: { count: removeCommas(e.target.value) },
              custom_id: dataItem.custom_id,
            })
          }
        />
      </div>
      <div className="mx-1">
        <CustomInput
          id="titleTour"
          label="قیمت واحد(تومان) "
          inputSize="same-as-select"
          type="text"
          inputContainer="price2-width"
          activate={typeId == 2 ? "disabled" : "active"}
          inputValue={addCommas(dataItem?.price)}
          onChangeFunc={(e) => {
            dispatch({
              type: ACTIONS.CHANGEITEM,
              payload: { price: removeCommas(e.target.value) },
              custom_id: dataItem.custom_id,
            });
          }}
        />
      </div>
      <div className="mx-1">
        <CustomInput
          id="titleTour"
          label="تخفیف(تومان) "
          inputSize="same-as-select"
          type="text"
          inputContainer="price-width"
          inputValue={addCommas(dataItem?.discount)}
          onChangeFunc={(e) =>
            dispatch({
              type: ACTIONS.CHANGEITEM,
              payload: { discount: removeCommas(e.target.value) },
              custom_id: dataItem.custom_id,
            })
          }
        />
      </div>
      <div className="mx-1">
        <CustomInput
          id="titleTour"
          label="مبلغ کل(تومان)"
          inputSize="same-as-select"
          type="text"
          inputContainer="price2-width"
          activate="disabled"
          inputValue={addCommas(
            (dataItem?.price - dataItem?.discount) * dataItem?.count > 0
              ? (dataItem?.price - dataItem?.discount) * dataItem?.count
              : 0
          )}
        />
      </div>

      {dataItem?.product?.properties != undefined &&
        dataItem?.product?.properties?.length > 0 &&
        dataItem?.product?.properties?.map((value) => {
          // console.log("propertyyyyyyyyyyyy", value?.property_id);

          if (value.type == 1) {
            return (
              <div className="mx-1" style={{ width: 150 }}>
                <CustomInput
                  inputContainer=""
                  label={`${value?.min_input} < ${value?.title} < ${value?.max_input}`}
                  inputSize="same-as-select"
                  inputValue={value?.input_value}
                  onChangeFunc={(e) => {
                    dispatch({
                      type: ACTIONS.PROPERTY,
                      payload: { input_value: e.target.value },
                      custom_id: dataItem.custom_id,
                      property_id: value?.property_id,
                    });
                  }}
                />
              </div>
            );
          } else if (value.type == 2) {
            let options = value.options.split(",") ?? [];
            options = options.map((v) => {
              return { value: v, label: v };
            });
            return (
              <div style={{ width: 150 }} className="mx-1">
                <ReactSelect
                  inputContainer="w-100"
                  title={value?.title}
                  itemsList={options}
                  inputValue={value?.input_value}
                  onChangeFunc={(e) => {
                    dispatch({
                      type: ACTIONS.PROPERTY,
                      payload: { input_value: e },
                      custom_id: dataItem.custom_id,
                      property_id: value?.property_id,
                    });
                  }}
                />
              </div>
            );
          }
        })}

      <div className="w-100 d-flex justify-content-end mt-1">
        <div className="mx-1 ">
          <CustomButton
            size="small"
            className=""
            onClick={() => {
              dispatch({
                type: ACTIONS.REMOVE,
                custom_id: dataItem.custom_id,
              });
            }}
            color="orange"
          >
            <TrashIcon
              containerIconClassName="me-1"
              style={{ width: 16, height: 16 }}
              color={ColorSchema.white_custom}
            />
            حذف
          </CustomButton>
        </div>
        {typeId == 2 && (order != "edit" || dataItem?.added) && (
          <div className="mx-1 position-relative">
            <div
              className="loader-container"
              style={{
                position: "absolute",
                left: "0",
                right: "0",
                top: "0",
                bottom: "0",
                overflow: "hidden",
                backgroundColor: "rgba(209, 225, 240)",
                zIndex: 5,
                borderRadius: 3,
                display: loadingPrice ? "block" : "none",
              }}
            >
              <TouchBallLoading />
            </div>
            <CustomButton
              size="small"
              className=""
              onClick={() => {
                if (callPriceValidation()) {
                  callForPriceFunc();
                  console.log("yeyeyeyye");
                } else {
                  console.log("neyeyyeye");
                }
              }}
              color="navy"
            >
              <SearchIcon
                containerIconClassName="me-1"
                style={{ width: 16, height: 16 }}
                color={ColorSchema.white_custom}
              />
              استعلام قیمت
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
}
